var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLogsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 9.99739C12.3012 9.99739 14.1667 8.13191 14.1667 5.83073C14.1667 3.52954 12.3012 1.66406 9.99999 1.66406C7.69881 1.66406 5.83333 3.52954 5.83333 5.83073C5.83333 8.13191 7.69881 9.99739 9.99999 9.99739Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0083 13.1181L13.0583 16.0682C12.9416 16.1848 12.8333 16.4015 12.8083 16.5598L12.65 17.6848C12.5916 18.0931 12.875 18.3765 13.2833 18.3181L14.4083 18.1598C14.5666 18.1348 14.7917 18.0265 14.9 17.9098L17.85 14.9598C18.3583 14.4515 18.6 13.8598 17.85 13.1098C17.1083 12.3681 16.5167 12.6098 16.0083 13.1181Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 13.5469C15.8333 14.4469 16.5333 15.1469 17.4333 15.3969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84164 18.3333C2.84164 15.1083 6.05 12.5 10 12.5C10.8667 12.5 11.7 12.625 12.475 12.8583",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogsLight);
export default __webpack_public_path__ + "static/media/user-logs-light.0ca088edd4d134e5c1e267556f703ff1.svg";
export { ForwardRef as ReactComponent };